import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=1fc3f4a3&scoped=true"
import script from "./questionDetail.vue?vue&type=script&lang=js"
export * from "./questionDetail.vue?vue&type=script&lang=js"
import style0 from "./questionDetail.vue?vue&type=style&index=0&id=1fc3f4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3f4a3",
  null
  
)

export default component.exports